import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

export const config = {
  rowSelection: true,
  columns: [
    {
      title: '物料SPU编码',
      key: 'code',
      dataIndex: 'code',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '物料SPU名称',
      key: 'name',
      dataIndex: 'name',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '物料SPU描述',
      key: 'description',
      dataIndex: 'description',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '品牌',
      key: 'brandName',
      dataIndex: 'brandName',
      width: 100,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '产地',
      key: 'manuLocation',
      dataIndex: 'manuLocation',
      width: 100,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '物料类型',
      key: 'typeName',
      dataIndex: 'typeName',
      width: 100,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '状态',
      key: 'spuStatus',
      dataIndex: 'spuStatus',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
      render: value => <span>{value ? '启用' : '停用'}</span>,
    },
    {
      title: '创建时间',
      key: 'createdTime',
      dataIndex: 'createdTime',
      width: 180,
      itemType: 'dateTime',
    },
    {
      title: (
        <span>
          有效产品数{' '}
          <Tooltip title="指该物料/施工SPU关联的有效的产品SPU个数">
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      ),
      key: 'validProductCount',
      dataIndex: 'validProductCount',
      width: 140,
      render: v => (v?  v : 0),
    },
    {
      title: '已上架分类',
      key: 'prdCategoryName',
      dataIndex: 'prdCategoryName',
      width: 300,
    },
  ],
  search: [
    {
      name: 'brandCode',
      label: '品牌',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'brandList',
      notFoundContent: '请选择品牌',
      addonOpts: [],
    },
    {
      name: 'manuLocationKeyword',
      label: '产地',
      itemType: 'input',
      placeholder: '请输入产地',
    },
    {
      name: 'code',
      label: '物料SPU编码',
      itemType: 'input',
      placeholder: '请输入物料SPU编码',
    },
    {
      name: 'nameKeyword',
      label: '物料SPU名称',
      itemType: 'input',
      placeholder: '请输入物料SPU名称',
    },
    {
      name: 'descriptionKeyword',
      label: '物料SPU描述',
      itemType: 'input',
      placeholder: '请输入物料SPU描述',
    },
    {
      name: 'validProductCount',
      label: '有效产品数',
      itemType: 'custom',
      render: 'numberRender',
      placeholder: '有效产品数',
    },
  ],
  footer: [
    {
      label: '列表数据全选',
      type: 'primary',
      ghost: true,
      events: ['onClick:allSelect'],
    },
  ],
  batchActions: [
    {
      label: '提交到产品库',
      type: 'primary',
      ghost: false,
      events: ['onClick:openCategoryModal'],
    },
  ],
}
